import React, { useState } from 'react';
import { ArrowRight, Wrench, Truck, Home, Settings, Palette, Building2, Shield, FileText, Users, CheckCircle, X } from 'lucide-react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const ServicesPage = () => {
  const [showQuoteModal, setShowQuoteModal] = useState(false);
  const [selectedService, setSelectedService] = useState('');
  const [activeFilter, setActiveFilter] = useState('All');
   const [quoteStatus, setQuoteStatus] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };


  const handleQuoteSubmit = async (e) => {
      e.preventDefault();
      setQuoteStatus('sending');

      try {
        const response = await fetch('https://gusgroupltd.com/api/send-email.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ...formData,
            type: 'quote',
            website: '' // Honeypot field
          }),
        });

        const data = await response.json();

        if (response.ok && data.success) {
          setQuoteStatus('success');
          setFormData({ name: '', email: '', phone: '', service: '', message: '' });
          
          // Auto-close modal after 3 seconds
          setTimeout(() => {
            setShowQuoteModal(false);
            setQuoteStatus('');
          }, 3000);
        } else {
          setQuoteStatus('error');
          setTimeout(() => {
            setQuoteStatus('');
          }, 5000);
        }
      } catch (error) {
        console.error('Error:', error);
        setQuoteStatus('error');
        setTimeout(() => {
          setQuoteStatus('');
        }, 5000);
      }
  };

  const services = [
    {
      icon: <Wrench className="w-12 h-12" />,
      title: "Remodeling & Renovations",
      category: "Construction",
      description: "Transform your existing spaces with our expert remodeling and renovation services.",
      image: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=800&h=600&fit=crop",
      features: [
        "Residential remodeling and upgrades",
        "Commercial property renovations",
        "Kitchen and bathroom modernization",
        "Structural modifications and extensions",
        "Energy-efficient upgrades",
        "Historical building restoration"
      ],
      benefits: [
        "Increased property value",
        "Improved functionality",
        "Modern aesthetic appeal",
        "Energy cost savings"
      ]
    },
    {
      icon: <Truck className="w-12 h-12" />,
      title: "Road Construction & Civil Works",
      category: "Infrastructure",
      description: "Building Ghana's infrastructure with quality road construction and civil engineering projects.",
      image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&h=600&fit=crop",
      features: [
        "Highway and road construction",
        "Bridge and overpass development",
        "Drainage and sewage systems",
        "Site preparation and earthworks",
        "Asphalt and concrete paving",
        "Traffic management solutions"
      ],
      benefits: [
        "Durable infrastructure",
        "Improved connectivity",
        "Economic development",
        "Safety compliance"
      ]
    },
    {
      icon: <Home className="w-12 h-12" />,
      title: "Real Estate Services",
      category: "Real Estate",
      description: "Comprehensive real estate solutions from property acquisition to management.",
      image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&h=600&fit=crop",
      features: [
        "Property buying and selling",
        "Real estate consultation",
        "Property valuation services",
        "Investment advisory",
        "Property management",
        "Lease and rental services"
      ],
      benefits: [
        "Expert market knowledge",
        "Fair property valuation",
        "Hassle-free transactions",
        "Long-term investment growth"
      ]
    },
    {
      icon: <Settings className="w-12 h-12" />,
      title: "Furniture Supply & Design",
      category: "Interior",
      description: "Custom and ready-made furniture solutions for residential and commercial spaces.",
      image: "https://images.unsplash.com/photo-1538688525198-9b88f6f53126?w=800&h=600&fit=crop",
      features: [
        "Custom furniture design and manufacturing",
        "Ready-made furniture supply",
        "Office furniture solutions",
        "Home furniture packages",
        "Outdoor and garden furniture",
        "Furniture installation services"
      ],
      benefits: [
        "Quality craftsmanship",
        "Tailored designs",
        "Competitive pricing",
        "Timely delivery"
      ]
    },
    {
      icon: <Palette className="w-12 h-12" />,
      title: "Interior & Exterior Decoration",
      category: "Design",
      description: "Modern design, painting, and finishing services to elevate your property's aesthetics.",
      image: "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=800&h=600&fit=crop",
      features: [
        "Interior design consultation",
        "Professional painting services",
        "Wall coverings and textures",
        "Ceiling design and installation",
        "Flooring solutions",
        "Exterior facade treatments"
      ],
      benefits: [
        "Enhanced visual appeal",
        "Personalized spaces",
        "Increased comfort",
        "Property value boost"
      ]
    },
    {
      icon: <Building2 className="w-12 h-12" />,
      title: "Building Development & Construction",
      category: "Construction",
      description: "Full-scale property development from groundbreaking to final handover.",
      image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&h=600&fit=crop",
      features: [
        "Residential building construction",
        "Commercial building projects",
        "Multi-story developments",
        "Turnkey construction solutions",
        "Project management",
        "Quality assurance and inspections"
      ],
      benefits: [
        "End-to-end service",
        "On-time delivery",
        "Budget compliance",
        "Quality guarantee"
      ]
    },
    {
      icon: <Shield className="w-12 h-12" />,
      title: "Importation & Exportation",
      category: "Trade",
      description: "International trade facilitation for construction materials and goods.",
      image: "https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=800&h=600&fit=crop",
      features: [
        "Construction materials import",
        "Equipment and machinery supply",
        "International sourcing",
        "Customs clearance assistance",
        "Logistics coordination",
        "Quality control and verification"
      ],
      benefits: [
        "Access to global markets",
        "Cost-effective sourcing",
        "Reliable supply chain",
        "Quality materials"
      ]
    },
    {
      icon: <FileText className="w-12 h-12" />,
      title: "Sales & Purchase of Properties",
      category: "Real Estate",
      description: "Facilitating seamless property transactions for land, residential, and commercial properties.",
      image: "https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=800&h=600&fit=crop",
      features: [
        "Land acquisition services",
        "Residential property sales",
        "Commercial property transactions",
        "Legal documentation support",
        "Title verification",
        "Property inspection services"
      ],
      benefits: [
        "Transparent processes",
        "Legal compliance",
        "Fair market pricing",
        "Secure transactions"
      ]
    },
    {
      icon: <Users className="w-12 h-12" />,
      title: "Consultancy Services",
      category: "Advisory",
      description: "Expert advisory in real estate, construction, and business development.",
      image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=600&fit=crop",
      features: [
        "Construction project consulting",
        "Real estate investment advice",
        "Feasibility studies",
        "Project cost estimation",
        "Risk assessment and management",
        "Strategic planning support"
      ],
      benefits: [
        "Expert guidance",
        "Risk mitigation",
        "Cost optimization",
        "Informed decisions"
      ]
    },
    {
      icon: <Settings className="w-12 h-12" />,
      title: "Facility Management & Maintenance",
      category: "Management",
      description: "Long-term upkeep and management of buildings and infrastructure.",
      image: "https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=800&h=600&fit=crop",
      features: [
        "Regular maintenance services",
        "Building systems management",
        "Preventive maintenance programs",
        "Emergency repair services",
        "Cleaning and janitorial services",
        "Security and safety management"
      ],
      benefits: [
        "Extended asset lifespan",
        "Reduced operational costs",
        "Improved efficiency",
        "Peace of mind"
      ]
    }
  ];

  const categories = ['All', 'Construction', 'Infrastructure', 'Real Estate', 'Interior', 'Design', 'Trade', 'Advisory', 'Management'];

  const filteredServices = activeFilter === 'All' 
    ? services 
    : services.filter(service => service.category === activeFilter);

  const processSteps = [
    {
      number: "01",
      title: "Initial Consultation",
      description: "We meet to understand your needs, vision, and budget requirements."
    },
    {
      number: "02",
      title: "Planning & Design",
      description: "Our team develops detailed plans and designs for your approval."
    },
    {
      number: "03",
      title: "Quote & Agreement",
      description: "Receive a comprehensive quote and sign the project agreement."
    },
    {
      number: "04",
      title: "Execution",
      description: "Our expert team brings your project to life with precision."
    },
    {
      number: "05",
      title: "Quality Check",
      description: "Rigorous quality inspections ensure excellence at every stage."
    },
    {
      number: "06",
      title: "Handover",
      description: "Final walkthrough and project handover with documentation."
    }
  ];

  return (
    <div className="bg-black text-white">
      <Navigation onQuoteClick={() => setShowQuoteModal(true)} />

      {/* Hero Section */}
      <section className="relative min-h-[60vh] flex items-center justify-center overflow-hidden pt-20">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1920&h=1080&fit=crop')",
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/40"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
          <h2 className="text-yellow-400 text-sm uppercase tracking-widest mb-4 font-semibold">
            Our Services
          </h2>
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Comprehensive
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">
              Construction Solutions
            </span>
          </h1>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            From concept to completion, we deliver exceptional results across all facets of construction and real estate
          </p>
        </div>
      </section>

      {/* Services Filter */}
      <section className="py-12 bg-gradient-to-b from-black to-gray-900 sticky top-20 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category, index) => (
              <button
                key={index}
                onClick={() => setActiveFilter(category)}
                className={`px-6 py-2 rounded-full font-semibold transition-all ${
                  activeFilter === category
                    ? 'bg-yellow-400 text-black'
                    : 'bg-gray-900 text-white hover:bg-gray-800 border border-yellow-400/20'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-24 bg-gradient-to-b from-gray-900 to-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12">
            {filteredServices.map((service, index) => (
              <div 
                key={index}
                className="bg-gradient-to-br from-gray-900 to-black rounded-2xl border border-yellow-400/20 hover:border-yellow-400/50 transition-all overflow-hidden group"
              >
                {/* Service Image */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <span className="bg-yellow-400 text-black px-3 py-1 rounded-full text-sm font-semibold">
                      {service.category}
                    </span>
                  </div>
                </div>

                {/* Service Content */}
                <div className="p-8">
                  <div className="w-16 h-16 bg-yellow-400/10 rounded-xl flex items-center justify-center mb-6">
                    <div className="text-yellow-400">
                      {service.icon}
                    </div>
                  </div>

                  <h3 className="text-3xl font-bold mb-4 text-white">
                    {service.title}
                  </h3>

                  <p className="text-gray-400 mb-6 text-lg">
                    {service.description}
                  </p>

                  {/* Features */}
                  <div className="mb-6">
                    <h4 className="text-yellow-400 font-semibold mb-3">What We Offer:</h4>
                    <ul className="space-y-2">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start gap-2 text-gray-300">
                          <CheckCircle className="w-5 h-5 text-yellow-400 flex-shrink-0 mt-0.5" />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Benefits */}
                  <div className="mb-6">
                    <h4 className="text-yellow-400 font-semibold mb-3">Key Benefits:</h4>
                    <div className="flex flex-wrap gap-2">
                      {service.benefits.map((benefit, idx) => (
                        <span 
                          key={idx}
                          className="bg-yellow-400/10 text-yellow-400 px-3 py-1 rounded-full text-sm border border-yellow-400/20"
                        >
                          {benefit}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* CTA Button */}
                  <button 
                    onClick={() => setShowQuoteModal(service.title)}
                    className="w-full bg-yellow-400 text-black px-6 py-3 rounded-full font-bold hover:bg-yellow-500 transition-all transform hover:scale-105 flex items-center justify-center gap-2"
                  >
                    Get Quote for This Service
                    <ArrowRight className="w-5 h-5" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Process */}
      <section className="py-24 bg-black relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-1/4 right-0 w-96 h-96 bg-yellow-400 rounded-full filter blur-3xl"></div>
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-yellow-400 text-sm uppercase tracking-widest mb-4 font-semibold">
              How We Work
            </h2>
            <h3 className="text-4xl md:text-5xl font-bold mb-6">
              Our Project Process
            </h3>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              A streamlined approach ensuring quality delivery from start to finish
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {processSteps.map((step, index) => (
              <div 
                key={index}
                className="bg-gradient-to-br from-gray-900 to-black p-8 rounded-2xl border border-yellow-400/20 hover:border-yellow-400/50 transition-all"
              >
                <div className="text-6xl font-bold text-yellow-400/20 mb-4">
                  {step.number}
                </div>
                <h4 className="text-2xl font-bold text-white mb-3">
                  {step.title}
                </h4>
                <p className="text-gray-400">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-24 bg-gradient-to-b from-gray-900 to-black">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-yellow-400 text-sm uppercase tracking-widest mb-4 font-semibold">
                Why Choose GUS Group
              </h2>
              <h3 className="text-4xl md:text-5xl font-bold mb-6">
                Your Trusted Construction Partner
              </h3>
              <p className="text-gray-300 text-lg mb-6">
                With 15+ years of experience and over 500 completed projects, GUS Group Ltd stands 
                as Ghana's premier construction company.
              </p>
              
              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-yellow-400/10 rounded-xl flex items-center justify-center flex-shrink-0">
                    <CheckCircle className="w-6 h-6 text-yellow-400" />
                  </div>
                  <div>
                    <h4 className="text-white font-bold mb-1">ISO Certified Quality</h4>
                    <p className="text-gray-400">ISO 9001:2015 certified processes ensuring world-class standards</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-yellow-400/10 rounded-xl flex items-center justify-center flex-shrink-0">
                    <CheckCircle className="w-6 h-6 text-yellow-400" />
                  </div>
                  <div>
                    <h4 className="text-white font-bold mb-1">Expert Team</h4>
                    <p className="text-gray-400">50+ highly skilled professionals dedicated to excellence</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-yellow-400/10 rounded-xl flex items-center justify-center flex-shrink-0">
                    <CheckCircle className="w-6 h-6 text-yellow-400" />
                  </div>
                  <div>
                    <h4 className="text-white font-bold mb-1">On-Time Delivery</h4>
                    <p className="text-gray-400">98% of projects delivered on or before deadline</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-yellow-400/10 rounded-xl flex items-center justify-center flex-shrink-0">
                    <CheckCircle className="w-6 h-6 text-yellow-400" />
                  </div>
                  <div>
                    <h4 className="text-white font-bold mb-1">Competitive Pricing</h4>
                    <p className="text-gray-400">Best value for money without compromising quality</p>
                  </div>
                </div>
              </div>

              <button 
                onClick={() => setShowQuoteModal(true)}
                className="bg-yellow-400 text-black px-8 py-3 rounded-full font-bold hover:bg-yellow-500 transition-all transform hover:scale-105 flex items-center gap-2"
              >
                Request a Quote
                <ArrowRight className="w-5 h-5" />
              </button>
            </div>

            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=800&h=600&fit=crop"
                alt="Construction site"
                className="rounded-2xl shadow-2xl"
              />
              <div className="absolute -bottom-6 -right-6 bg-yellow-400 text-black p-6 rounded-xl shadow-xl">
                <h4 className="text-4xl font-bold">500+</h4>
                <p className="font-semibold">Projects Completed</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-r from-yellow-400 to-yellow-600 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-full h-full" style={{
            backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(0,0,0,.1) 35px, rgba(0,0,0,.1) 70px)'
          }}></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-black">
            Ready to Start Your Project?
          </h2>
          <p className="text-xl text-black/80 mb-8 max-w-2xl mx-auto">
            Get a free consultation and quote for any of our services
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => setShowQuoteModal(true)}
              className="bg-black text-yellow-400 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-900 transition-all transform hover:scale-105 flex items-center gap-2 justify-center"
            >
              Get Free Quote
              <ArrowRight className="w-5 h-5" />
            </button>
            <a 
              href="tel:0592668258"
              className="border-2 border-black text-black px-8 py-4 rounded-full font-bold text-lg hover:bg-black hover:text-yellow-400 transition-all"
            >
              Call: 0592668258
            </a>
          </div>
        </div>
      </section>

      <Footer />

      {/* Quote Modal */}
      {showQuoteModal && (
        <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-gradient-to-br from-gray-900 to-black border border-yellow-400/30 rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-8">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-3xl font-bold text-white">Request a Quote</h3>
                <button
                  onClick={() => setShowQuoteModal(false)}
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-yellow-400 hover:text-black transition-all"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>

              {/* Status Messages */}
              {quoteStatus === 'sending' && (
                <div className="mb-6 bg-blue-500/10 border border-blue-500/50 rounded-xl p-4 flex items-start gap-3">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500"></div>
                  <div>
                    <h4 className="text-blue-500 font-bold mb-1">Sending Request...</h4>
                    <p className="text-gray-300 text-sm">Please wait while we process your quote request.</p>
                  </div>
                </div>
              )}

              {quoteStatus === 'success' && (
                <div className="mb-6 bg-green-500/10 border border-green-500/50 rounded-xl p-4 flex items-start gap-3">
                  <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" />
                  <div>
                    <h4 className="text-green-500 font-bold mb-1">Quote Request Sent Successfully!</h4>
                    <p className="text-gray-300 text-sm">Thank you! We'll contact you soon with your quote. This window will close automatically.</p>
                  </div>
                </div>
              )}

              {quoteStatus === 'error' && (
                <div className="mb-6 bg-red-500/10 border border-red-500/50 rounded-xl p-4 flex items-start gap-3">
                  <X className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" />
                  <div>
                    <h4 className="text-red-500 font-bold mb-1">Failed to Send Request</h4>
                    <p className="text-gray-300 text-sm">Please try again or call us directly at 0592668258</p>
                  </div>
                </div>
              )}

              <form onSubmit={handleQuoteSubmit} className="space-y-6">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-semibold text-gray-300 mb-2">Full Name *</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      disabled={quoteStatus === 'sending'}
                      className="w-full px-4 py-3 bg-black border border-gray-700 rounded-lg text-white focus:border-yellow-400 focus:outline-none transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                      placeholder="John Doe"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-300 mb-2">Email *</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      disabled={quoteStatus === 'sending'}
                      className="w-full px-4 py-3 bg-black border border-gray-700 rounded-lg text-white focus:border-yellow-400 focus:outline-none transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                      placeholder="john@example.com"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-300 mb-2">Phone *</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    disabled={quoteStatus === 'sending'}
                    className="w-full px-4 py-3 bg-black border border-gray-700 rounded-lg text-white focus:border-yellow-400 focus:outline-none transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                    placeholder="0501234567"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-300 mb-2">Service Required *</label>
                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleInputChange}
                    required
                    disabled={quoteStatus === 'sending'}
                    className="w-full px-4 py-3 bg-black border border-gray-700 rounded-lg text-white focus:border-yellow-400 focus:outline-none transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <option value="">Select a service</option>
                    {services.map((service, i) => (
                      <option key={i} value={service.title}>{service.title}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-300 mb-2">Project Details *</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    disabled={quoteStatus === 'sending'}
                    rows="5"
                    className="w-full px-4 py-3 bg-black border border-gray-700 rounded-lg text-white focus:border-yellow-400 focus:outline-none transition-all resize-none disabled:opacity-50 disabled:cursor-not-allowed"
                    placeholder="Tell us about your project requirements, timeline, budget, etc."
                  ></textarea>
                </div>

                <div className="flex gap-4">
                  <button
                    type="button"
                    onClick={() => {
                      setShowQuoteModal(false);
                      setQuoteStatus('');
                    }}
                    disabled={quoteStatus === 'sending'}
                    className="flex-1 border-2 border-gray-700 text-white px-8 py-4 rounded-full font-bold hover:border-yellow-400 hover:text-yellow-400 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={quoteStatus === 'sending' || quoteStatus === 'success'}
                    className="flex-1 bg-yellow-400 text-black px-8 py-4 rounded-full font-bold hover:bg-yellow-500 transition-all transform hover:scale-105 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                  >
                    {quoteStatus === 'sending' ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-black"></div>
                        Sending...
                      </>
                    ) : (
                      <>
                        Submit Request
                        <ArrowRight className="w-5 h-5" />
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* WhatsApp Floating Button */}
      
        <a href="https://wa.me/233592668258?text=Hello%20GUS%20Group,%20I'm%20interested%20in%20your%20services"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 w-16 h-16 bg-green-500 rounded-full flex items-center justify-center shadow-2xl hover:bg-green-600 transition-all transform hover:scale-110 z-40"
      >
        <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
      </a>
    </div>
  );
};

export default ServicesPage;